import React from 'react';
import './Banner.css'
import Box from '@mui/material/Box';
import { Grid, Container, Typography } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import learnChinese from '../../../images/learn-chinese.png'
import ParticlesBackground from '../../../ParticlesBackground/ParticlesBackground';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
const Banner = () => {

    return (

        <>
            <ParticlesBackground />
            <Box className="banner">
                <Container>
                    <Grid container spacing={2}>
                        <Grid item style={{ width: "50%", textAlign: "left", paddingTop: "70px" }}>
                            {/* <Typography data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine" variant="subtitle1" gutterBottom component="div">
                            Learn Practice Build
                        </Typography> */}
                            <Typography data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine" sx={{ fontFamily: 'Raleway', fontWeight: "700", pb: 0, }} variant="h2" gutterBottom component="div">
                                <span style={{ borderBottom: '3px solid #8341ED' }}>Learn</span> Apply Ask & Repeat
                            </Typography>
                            <Typography data-aos="zoom-out-up" data-aos-easing="ease-in-sine"
                                data-aos-duration="1000" sx={{ fontSize: "12px", fontFamily: 'Raleway', lineHeight: "20px" }} variant="h6" gutterBottom>
                                The best way of learning a language is through practice! Learn Chinese with .<strong>Language Buddy</strong> best platform to make your Chinese level higher.
                            </Typography>

                            <NavLink to="/explore">
                                <button className="primary-button transition">
                                    <LibraryBooksIcon />View Courses
                                </button>
                            </NavLink>
                            {/* <NavLink to="/explore" data-aos="zoom-out-up"
                                data-aos-duration="1000" data-aos-easing="ease-in-sine">
                                <button className="primary-button transition">
                                    
                                </button>
                            </NavLink> */}

                        </Grid>

                        <Grid item sx={{ width: "50%", textAlign: "right" }} >
                            <img data-aos="fade-left"
                                data-aos-easing="ease-in-sine"
                                data-aos-duration="1000"
                                src={learnChinese} alt="" />
                        </Grid>
                    </Grid>
                </Container>

            </Box>

        </>
    );
};

export default Banner;